import { defineMessage } from 'services/localization';

export const messages = {
    forceDecisionMenuButtonText: defineMessage('force_decision'),
    title: defineMessage('forcing_the_approval_decision'),
    description: defineMessage('as_an_administrator_you_ions_of_other_approvers'),
    forceApprovalButtonText: defineMessage('force_the_approval'),
    forceRejectionButtonText: defineMessage('force_the_rejection'),
    forceDecisionMenuButtonTitle: defineMessage('force_the_approval_rejection_of_this_request'),
    forceApprovalButtonTitle: defineMessage('force_approval_of_this__e_company_administrator'),
    forceRejectionButtonTitle: defineMessage('force_rejection_of_this_e_company_administrator'),
};
